import { render, staticRenderFns } from "./LomDescription.vue?vue&type=template&id=6eb39852"
import script from "./LomDescription.vue?vue&type=script&lang=js"
export * from "./LomDescription.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports